module.exports = __webpack_public_path__ + "static/media/solo-dark.17da28b9.svg";